/**
 * Проверяет поддержку VP9 кодека в браузере
 */
const checkVP9Support = (): boolean => {
    try {
        const capabilities = RTCRtpReceiver.getCapabilities('video');
        if (!capabilities) return false;

        return capabilities.codecs.some((codec) => codec.mimeType.toLowerCase().includes('vp9'));
    } catch (error) {
        console.warn('[Codec] Failed to check VP9 support:', error);
        return false;
    }
};

/**
 * Получает оптимальный кодек для LiveKit
 * Возвращает 'vp9' если поддерживается, иначе undefined (LiveKit сам выберет vp8/h264)
 */
export const getOptimalVideoCodec = (): 'vp9' | undefined => {
    return checkVP9Support() ? 'vp9' : undefined;
};
